<template>
 <div class="strongBase">
     <router-view></router-view>
 </div>
</template>
<script>
export default {
    name:'strongBase',
    data(){
        return {

        }
    }
}
</script>

<style style="less" scoped>

</style>